import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleSearchSpecification extends FlexibleBaseSpecification {
	id: number;
	title: string;
}

export class FlexibleSearchModel extends FlexibleModelBase {
	public readonly title: string;

	constructor(spec: FlexibleSearchSpecification) {
		super(spec);

		this.title = spec.title;
	}
}
